import React from "react";
import { useTheme } from "../context/ThemeContext";
import "./home.css";
import Typewriter from "typewriter-effect";
import Shivukumara_Resume from "../assets/Shivukumara_Resume.pdf";
import { BsFillMoonStarsFill, BsSunFill } from "react-icons/bs";
import Fade from "react-reveal/Fade";

const Home = () => {
  const [theme, setTheme] = useTheme();

  // handle theme
  const handleTheme = () => {
    setTheme((prevState) => (prevState === "light" ? "dark" : "light"));
  };

  return (
    <>
      <div className="container-fluid home-container" id="home">
        <div className="theme-btn" onClick={handleTheme}>
          {theme === "light" ? (
            <BsFillMoonStarsFill size={30} />
          ) : (
            <BsSunFill size={30} />
          )}
        </div>
        <div className="container home-content">
          <Fade right>
            <h2>Hi I'm</h2>
            <h1>
              <Typewriter
                options={{
                  strings: ["SHIVUKUMARA"],
                  autoStart: true,
                  loop: true,
                }}
              />
            </h1>
            <h1>
              <Typewriter
                options={{
                  strings: ["JAVA Full Stack Developer!", "MERN Stack Developer!"],
                  autoStart: true,
                  loop: true,
                }}
              />
            </h1>
          </Fade>
          <Fade bottom>
            <div className="home-buttons">
              <a
                className="btn btn-hire"
                href="https://api.whatsapp.com/send?phone=7204247286"
                rel="noreferrer"
                target="_blank"
              >
                Hire Me
              </a>
              <a
                className="btn btn-cv"
                href={Shivukumara_Resume}
                download="Shivukumara_Resume.pdf"
              >
                My Resume
              </a>
            </div>
          </Fade>
        </div>
      </div>
    </>
  );
};

export default Home;
